import React from 'react'
import '../../styles/shortcut.css'
function Shortcut() {
  return (

    <div className='flex flex-col gap-y-2 justify-center items-center text-center p-4'>
      <h1 className='text-2xl font-extrabold text-[#0D5376] dark:text-white'>Voice &#8594; Text</h1>
      {/* <h1 className='text-2xl font-extrabold text-[#0D5376] dark:text-white'>Convert spoken words to written text</h1> */}
      <h3 className='text-md font-extrabold text-[#0D5376] dark:text-white mt-5'>Press A to start recording</h3>
      <h3 className='text-md font-extrabold text-[#0D5376] dark:text-white'>Press S to stop and convert to text</h3>
      <h3 className='text-md font-extrabold text-[#0D5376] dark:text-white'>Press C to copy text into your clipboard</h3>
    </div>
  )
}

export default Shortcut